import { memo, useCallback } from 'react';

import styles from './styles.module.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface DropdownOption<T = any> {
  label: string;
  value: T;
}

type Props = {
  option: DropdownOption;
  onClick: (option: DropdownOption) => void;
};

export const DropdownItem: React.FC<Props> = memo(function DropdownItem({ option, onClick }) {
  const handleClick = useCallback(() => {
    onClick(option);
  }, [onClick, option]);

  return (
    <div className={styles.container} onClick={handleClick}>
      <p>{option.label}</p>
    </div>
  );
});
